import {
  DateRange,
  TimelineTimeframes,
  Timestamp,
  WeekDays,
} from '@griply/types';
import {
  addYears,
  endOfWeek,
  endOfYear,
  startOfWeek,
  startOfYear,
} from 'date-fns';

import { weekdaysNumberMap } from './constants';

export type GetTimelineDateRangeOptions = {
  referenceDate: Timestamp;
  timeframe: TimelineTimeframes;
  weekStartsOn: WeekDays;
};

const YEARS_BEFORE = 2;
const YEARS_AFTER = 10;

export const getTimelineDateRange = ({
  referenceDate,
  timeframe,
  weekStartsOn,
}: GetTimelineDateRangeOptions): DateRange => {
  const startYear = startOfYear(addYears(referenceDate, -YEARS_BEFORE));
  const endYear = endOfYear(addYears(referenceDate, YEARS_AFTER));

  if (timeframe === TimelineTimeframes.Month) {
    return {
      startDate: startOfWeek(startYear, {
        weekStartsOn: weekdaysNumberMap[weekStartsOn],
      }),
      endDate: endOfWeek(endYear, {
        weekStartsOn: weekdaysNumberMap[weekStartsOn],
      }),
    };
  }

  return {
    startDate: startYear,
    endDate: endYear,
  };
};
